import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import ComplianceCard from "."
import moment from "moment"
import { connect } from "react-redux"
import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import PropTypes from "prop-types"

const generateQuery = ({ entityType, bsrCompliance }) => gql`
  query ComplianceCard($entityId: ID!, $startAt: String!, $endAt: String!, $prevStartAt: String!, $prevEndAt: String!) {
    entity: ${entityType}(id: $entityId) {
      id
      compliance: ${
        bsrCompliance ? "bsrCompliance" : "roundingCompliance"
      }(startAt: $startAt, endAt: $endAt) {
        timeslices {
          full {
            aggregates {
              overall {
                compliancePercentage,
                ${
                  bsrCompliance
                    ? "compliantOpportunityCount"
                    : "compliantRoundCount"
                },
                ${bsrCompliance ? "opportunityCount" : "roundCount"},
              }
            }
          }
        }
      },
      prevCompliance: ${
        bsrCompliance ? "bsrCompliance" : "roundingCompliance"
      }(startAt: $prevStartAt, endAt: $prevEndAt) {
        timeslices {
          full {
            aggregates {
              overall {
                compliancePercentage,
                ${
                  bsrCompliance
                    ? "compliantOpportunityCount"
                    : "compliantRoundCount"
                },
                ${bsrCompliance ? "opportunityCount" : "roundCount"},
              }
            }
          }
        }
      }
    }
  }
`

const ComplianceCardWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId, startAt, endAt }) => ({
    variables: {
      entityId,
      startAt: startAt.format(GRAPHQL_DATE_FORMAT),
      endAt: endAt.format(GRAPHQL_DATE_FORMAT),
      prevStartAt: getPreviousPeriod(startAt, endAt).startDate.format(
        GRAPHQL_DATE_FORMAT
      ),
      prevEndAt: getPreviousPeriod(startAt, endAt).endDate.format(
        GRAPHQL_DATE_FORMAT
      ),
    },
  }),
  props: ({
    data: { error, loading, entity },
    ownProps: { bsrCompliance },
  }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }

      const aggs = entity.compliance.timeslices.full.aggregates.overall
      const compliance = aggs.compliancePercentage
      const opportunities = bsrCompliance
        ? aggs.opportunityCount
        : aggs.roundCount

      const change =
        compliance -
        entity.prevCompliance.timeslices.full.aggregates.overall
          .compliancePercentage

      return {
        loading,
        change,
        compliance,
        opportunities,
        title: `${
          bsrCompliance
            ? "Bedside Shift Report Compliance"
            : "Nurse Rounding Compliance"
        }`,
      }
    } else {
      return {
        loading,
      }
    }
  },
})(ComplianceCard)

/*
Returns the previous start and end date of the same duration. Note this will
will be off by a day if the periods are months (e.g. for 12/1 - 12/31, the
previous period would calculate to 10/31 - 11/30)
*/
const getPreviousPeriod = (date1, date2) => {
  const endDate = moment(date1).subtract(1, "day")
  const diffInSecs = moment(date2).diff(moment(date1))
  return { startDate: moment(endDate).subtract(diffInSecs), endDate: endDate }
}

const ComplianceCardWithData = connect(
  ({
    dateRange: { startDate, endDate },
    bsrCompliance: { bsrCompliance },
  }) => ({
    startAt: moment(startDate),
    endAt: moment(endDate),
    bsrCompliance,
  })
)(ComplianceCardWithApollo)

ComplianceCardWithData.propTypes = {
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.oneOf(["facility", "department", "unit"]).isRequired,
}

export default ComplianceCardWithData
